/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react'
import {
  Box,
  Button,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from '@material-ui/core'

import BaseFilterModal from '../../../../components/hooks/BaseFilterModal'
import filterStylesComponents from '../../../../assets/filterComponentsStyles'
import colors from '../../../../assets/colors'
import { CustomSwitch } from '../../../../components/ui/custom-switch'

const INITIAL_VALUES = {
  label: '',
  type: 'boolean',
  is_required: false,
  status: true,
}

const QuestionModal = ({ open, question, handleClose, onSubmit }) => {
  const classes = filterStylesComponents()

  const [values, setValues] = useState(INITIAL_VALUES)
  const [submitting, setSubmitting] = useState(false)

  const isEdit = !!question?.id

  useEffect(() => {
    if (!open) return

    setValues(
      isEdit
        ? {
            label: question?.label || '',
            type: question?.type || 'boolean',
            is_required: !!question?.is_required,
            status: !!question?.status,
          }
        : INITIAL_VALUES
    )
  }, [open, question?.id])

  const handleChange = (field, value) =>
    setValues(current => ({ ...current, [field]: value }))

  const handleSubmit = async event => {
    event.preventDefault()

    if (submitting) return

    setSubmitting(true)
    // na edição só o que mudou é enviado (todos os campos são "sometimes" na api)
    const payload = isEdit
      ? Object.keys(values).reduce(
          (changed, field) =>
            values[field] === question[field]
              ? changed
              : { ...changed, [field]: values[field] },
          {}
        )
      : values

    await onSubmit(payload)
    setSubmitting(false)
  }

  return (
    <BaseFilterModal
      open={open}
      title={isEdit ? 'Editar Pergunta' : 'Nova Pergunta'}
      hiddenHelpButton
      handleOpen={handleClose}
    >
      <Grid item xs={12} style={{ width: '420px' }}>
        <form style={{ width: '100%' }} onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                required
                autoFocus
                multiline
                name="label"
                label="Pergunta"
                placeholder="Ex.: O móvel/objeto possui algum estrago?"
                inputProps={{ maxLength: 255 }}
                value={values.label}
                onChange={event => handleChange('label', event.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                select
                fullWidth
                name="type"
                label="Tipo de resposta"
                value={values.type}
                onChange={event => handleChange('type', event.target.value)}
              >
                <MenuItem value="boolean">Sim/Não</MenuItem>
                <MenuItem value="text">Texto</MenuItem>
              </TextField>
            </Grid>

            <Grid item xs={12}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <Box>
                  <Typography style={{ color: colors.textCustom }}>
                    Obrigatória
                  </Typography>
                  <Typography
                    style={{ color: colors.textGray, fontSize: '13px' }}
                  >
                    O app exige a resposta para fechar a visita
                  </Typography>
                </Box>
                <CustomSwitch
                  checked={values.is_required}
                  onChange={event =>
                    handleChange('is_required', event.target.checked)
                  }
                />
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <Box>
                  <Typography style={{ color: colors.textCustom }}>
                    Ativa
                  </Typography>
                  <Typography
                    style={{ color: colors.textGray, fontSize: '13px' }}
                  >
                    Desativada, a pergunta deixa de aparecer no app
                  </Typography>
                </Box>
                <CustomSwitch
                  checked={values.status}
                  onChange={event =>
                    handleChange('status', event.target.checked)
                  }
                />
              </Box>
            </Grid>

            <Grid
              item
              xs={12}
              container
              alignItems="center"
              justifyContent="flex-end"
            >
              <Button
                type="button"
                onClick={handleClose}
                className={classes.btnMoreFilters}
              >
                Cancelar
              </Button>

              <Button
                type="submit"
                className={classes.btnAdd}
                disabled={submitting || !values.label.trim()}
              >
                Salvar
              </Button>
            </Grid>
          </Grid>
        </form>
      </Grid>
    </BaseFilterModal>
  )
}

export default QuestionModal
